import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "text-sm" }
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-muted-foreground mt-0.5"
}
const _hoisted_4 = {
  key: 0,
  class: "fixed bottom-4 right-80 z-[90] bg-background border rounded-lg shadow-lg p-3 flex items-center gap-3 w-56"
}
const _hoisted_5 = { class: "flex-shrink-0 h-8 w-8 rounded bg-primary/10 flex items-center justify-center" }
const _hoisted_6 = { class: "flex items-center gap-1 flex-shrink-0" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useHelpCenter } from '@/composables/useHelpCenter'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { HelpCircle, BookOpen, Maximize2, X, Sparkles } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'HelpCenterWidget',
  setup(__props) {

const route = useRoute()
const { state, open, restore, close, openContextual, getSuggestedGuide, hasContextualHelp } =
  useHelpCenter()

// Verificar si hay ayuda contextual para la ruta actual
const hasContextual = computed(() => hasContextualHelp(route.path))
const suggestedGuide = computed(() => getSuggestedGuide(route.path))

const handleOpen = () => {
  if (hasContextual.value) {
    openContextual(route.path)
  } else {
    open()
  }
}

const tooltipText = computed(() => {
  if (suggestedGuide.value) {
    return `Ayuda: ${suggestedGuide.value.title}`
  }
  return 'Centro de Ayuda'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300 ease-out",
      "leave-active-class": "transition-all duration-200 ease-in",
      "enter-from-class": "opacity-0 scale-75",
      "enter-to-class": "opacity-100 scale-100",
      "leave-from-class": "opacity-100 scale-100",
      "leave-to-class": "opacity-0 scale-75"
    }, {
      default: _withCtx(() => [
        (!_unref(state).isOpen && !_unref(state).isMinimized)
          ? (_openBlock(), _createBlock(_unref(TooltipProvider), { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_unref(Tooltip), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Button), {
                          variant: "default",
                          size: "icon",
                          class: _normalizeClass(["fixed bottom-4 right-4 z-[80] h-12 w-12 rounded-full shadow-lg group", hasContextual.value ? 'ring-2 ring-primary/50 ring-offset-2 ring-offset-background' : '']),
                          onClick: handleOpen
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_1, [
                              _createVNode(_unref(HelpCircle), { class: "h-6 w-6" }),
                              (hasContextual.value)
                                ? (_openBlock(), _createBlock(_unref(Sparkles), {
                                    key: 0,
                                    class: "absolute -top-1 -right-1 h-3 w-3 text-yellow-400 animate-pulse"
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TooltipContent), {
                      side: "left",
                      "side-offset": 8
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_2, _toDisplayString(tooltipText.value), 1),
                        (hasContextual.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Click para ver guía contextual "))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300 ease-out",
      "leave-active-class": "transition-all duration-200 ease-in",
      "enter-from-class": "opacity-0 translate-y-4 scale-95",
      "enter-to-class": "opacity-100 translate-y-0 scale-100",
      "leave-from-class": "opacity-100 translate-y-0 scale-100",
      "leave-to-class": "opacity-0 translate-y-4 scale-95"
    }, {
      default: _withCtx(() => [
        (_unref(state).isMinimized)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(BookOpen), { class: "h-4 w-4 text-primary" })
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-1 min-w-0" }, [
                _createElementVNode("p", { class: "text-sm font-medium truncate" }, "Centro de Ayuda"),
                _createElementVNode("p", { class: "text-xs text-muted-foreground" }, "Minimizado")
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  size: "icon",
                  class: "h-7 w-7",
                  onClick: _unref(restore),
                  title: "Restaurar"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Maximize2), { class: "h-3.5 w-3.5" })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  size: "icon",
                  class: "h-7 w-7 text-muted-foreground hover:text-destructive",
                  onClick: _unref(close),
                  title: "Cerrar"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(X), { class: "h-3.5 w-3.5" })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})